// Central map of route → browser-tab title, so the tab updates as the user moves around
// (like Gmail showing "Inbox" vs "Starred"). Applied once in Root on every location change.

const APP_NAME = 'MTT';
const BRAND_TITLE = 'MTT — My Telling Tale';

const PAGE_TITLES: Record<string, string> = {
  '/': BRAND_TITLE,
  '/signup': 'Sign Up',
  '/signin': 'Sign In',
  '/verify': 'Verify Your Email',
  '/verified': 'Email Verified',
  '/profile': 'Set Up Your Profile',
  '/connect': 'Connect Family',
  '/home': 'Your Stories',
  '/create/pick': 'Pick a Moment',
  '/create/prompts': 'Story Prompts',
  '/create/story': 'Story Builder',
  '/create/organize': 'Organize Your Story',
  '/create/preview': 'Preview',
  '/create/share': 'Share Settings',
  '/create/done': 'Story Created',
  '/network': 'Family Network',
  '/my-profile': 'My Profile',
  '/edit/video': 'Video Editor',
  '/edit/story': 'Edit Story',
  '/edit/success': 'Upload Complete',
  '/subscribe': 'Subscribe',
  '/design': 'Design System',
  '/settings': 'Settings',
};

/** Returns the document title for a pathname, e.g. "Settings · MTT". */
export function titleForPath(pathname: string): string {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const page = PAGE_TITLES[normalized];
  if (!page || normalized === '/') return BRAND_TITLE;
  return `${page} · ${APP_NAME}`;
}
